import React from 'react';

export const requiredCustomDocumentStack = [
  {
    name: 'documentName',
    label: 'Document Name',
    placeholder: 'Custom Document Name',
    required: true,
    validationRules: {
      required: { value: true, message: 'Custom Document Name is a required field' },
      minLength: { value: 3, message: 'Custom Document must have at least three characters' },
      maxLength: { value: 191, message: 'Custom Document Name must be 191 characters or fewer' }
    }
  },
  {
    name: 'description',
    label: 'Description',
    placeholder: 'Type your thoughts...',
    toolTip: 'Here is some helpful explainer text to assist the user in understanding how a certain feature works.',
    type: 'textArea',
    validationRules: {
      maxLength: { value: 500, message: 'Custom Document Description must have fewer than 500 characters' }
    }
  }
];
